import { render } from "./RecognitionOptions.vue?vue&type=template&id=620bca8c"
import script from "./RecognitionOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./RecognitionOptions.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/RecognitionOptions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "620bca8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('620bca8c', __exports__)) {
    api.reload('620bca8c', __exports__)
  }
  
  module.hot.accept("./RecognitionOptions.vue?vue&type=template&id=620bca8c", () => {
    api.rerender('620bca8c', render)
  })

}


export default __exports__